import { IMenu } from '../../../redux/initState/InterfacesState';
import { EnumUrlsPages } from '../../../services/Enum';
import MenuPopupDelivery from '../MenuPopupDelivery/MenuPopupDelivery';
import MenuPopupTeam from '../MenuPopupTeam/MenuPopupTeam';
import {content} from "../../../services/content";

export const MenuTopList: IMenu[] = [
  {
    text: content.header.textsMenu.services,
    link: '',
    subComponent: ({ onClickLink }: { onClickLink: any }) => {
      return <MenuPopupDelivery onClickLink={onClickLink} showDelivery={false} showServices={true} />;
    },
    intoLink: false,
    hash: false,
  },
  { text: content.header.textsMenu.tariffs, link: EnumUrlsPages.calculator, intoLink: false, hash: false },
  {
    text: content.header.textsMenu.delivery,
    link: '',
    subComponent: ({ onClickLink }: { onClickLink: any }) => {
      return <MenuPopupDelivery onClickLink={onClickLink} showDelivery={true} showServices={false} />;
    },
    intoLink: false,
    hash: false,
  },
  { text: content.header.textsMenu.live, link: EnumUrlsPages.live, intoLink: false, hash: false, mark: true },
  { text: content.header.textsMenu.contacts,
    link: EnumUrlsPages.contacts,
    intoLink: false,
    hash: false,
    subComponent: ({ onClickLink }: { onClickLink: any }) => {
      return <MenuPopupTeam onClickLink={onClickLink} />;
    },
  },
];

export const LKLinks: IMenu[] = [
  {
    text: content.header.textsMenu.cabinet,
    link: '',
    subMenu: [
      { text: content.header.textsMenu.cityMoscow, link: 'https://lk.dalli-service.com/login.php', intoLink: true },
      { text: content.header.textsMenu.cityPetersburg, link: 'https://spblk.dalli-service.com/login.php', intoLink: true },
    ],
  },
];
